module.exports = __webpack_public_path__ + "af8e5d07dbfbf40dbb8a3a27aa23c023.MP3";